import { IconButton } from '@mui/material'
import { Logout } from 'mdi-material-ui'
import { useProject } from 'queries/queries'
import React from 'react'
import { getProjectId } from 'utilities/get-project-id'
import { clearLocalData } from 'utilities/use-local-data'
import { useNavigateProject } from 'utilities/use-navigate-project'
import { useStaticCallback } from 'utilities/use-static-callback'
import HeaderLogoView, { Props as HeaderLogoViewProps } from './header-logo-view'

type Props = { displayLogout?: boolean } & Pick<HeaderLogoViewProps, 'size'>

const HeaderLogoContainer = (props: React.PropsWithChildren<Props>) => {
  const { size, displayLogout = false } = props
  const projectId = getProjectId()
  const { data: project } = useProject({ projectId })
  const navigate = useNavigateProject()

  const handleAbortClick = useStaticCallback(() => {
    clearLocalData()
    navigate(`/`)
  })

  return (
    <div className="relatieve w-full">
      {displayLogout && (
        <IconButton className="absolute rotate-180" onClick={handleAbortClick}>
          <Logout />
        </IconButton>
      )}
      <HeaderLogoView
        projectUrl={project?.projectUrl ?? ''}
        logotypeUrl={project?.logotypeUrl ?? ''}
        logotypeAlt={project?.name ?? ''}
        size={size}
      />
    </div>
  )
}

export default HeaderLogoContainer
